import React from 'react';

const PrivacyPolicy = () => {
  const lastUpdated = "Jan, 2026";
  const grievanceOfficer = {
    name: "Sri Krishna",
    email: "info@donatepe.com",
    address: "Hyderabad, India"
  };

  return (
    <div className="privacy-container">
      <div className="privacy-content">
        <h1>Privacy Policy</h1>
        
        <p className="last-updated">Last Updated: {lastUpdated}</p>

        <p><strong>Legal Entity:</strong> DonatePe is owned and operated by Lord Welfare Organisation, a registered organisation in India, and acts as the data fiduciary under applicable Indian laws.</p>

        <section>
          <h2>1. Introduction</h2>
          <p>Welcome to DonatePe, a crowdfunding platform owned and operated by Lord Welfare Organisation ("NGO"). We value your trust and are committed to protecting your personal data. This Privacy Policy explains how we collect, use, and safeguard your information when you use our platform for crowdfunding, donations, or campaigning in India.</p>
        </section>

        <section>
          <h2>2. Information We Collect</h2>
          <p>We collect information that allows us to provide a secure and transparent crowdfunding environment:</p>
          <p><strong>Personal Identifiers:</strong> Name, email address, phone number, and postal address.</p>
          <p><strong>Verification Data (KYC):</strong> For campaigners, we collect Aadhaar, PAN card details, and bank account information as required by Indian law.</p>
          <p><strong>Transaction Data:</strong> Details of donations made, payment methods (processed via secure third-party gateways), and history of contributions.</p>
          <p><strong>Medical/Sensitive Data:</strong> For medical fundraisers, we may collect hospital bills and medical reports to verify the authenticity of the cause.</p>
        </section>

        <section>
          <h2>3. Purpose of Data Processing</h2>
          <p>Your data is used strictly for the following:</p>
          <p>Verifying the identity of campaigners to prevent fraud.</p>
          <p>Processing donations and issuing 80G tax-exempt receipts (where applicable).</p>
          <p>Communicating updates about the progress of a supported campaign.</p>
          <p>Complying with legal obligations under the IT Act and DPDPA 2023.</p>
        </section>

        <section>
          <h2>4. Data Sharing and Disclosure</h2>
          <p>We do not sell your data. However, we share information in the following scenarios:</p>
          <p><strong>With Campaigners:</strong> Donors' names and amounts may be shared with campaigners unless the donor chooses the "Anonymous" option.</p>
          <p><strong>With Payment Partners:</strong> To process transactions via UPI, credit cards, or net banking.</p>
          <p><strong>Legal Necessity:</strong> If required by Indian law enforcement or regulatory bodies like SEBI or the Income Tax Department.</p>
        </section>

        <section>
          <h2>5. Your Rights (DPDPA 2023 Compliance)</h2>
          <p>Under the Digital Personal Data Protection Act, you have the right to:</p>
          <p><strong>Right to Access:</strong> Request a summary of the personal data we hold about you.</p>
          <p><strong>Right to Correction/Erasure:</strong> Ask us to update incorrect data or delete data that is no longer necessary.</p>
          <p><strong>Right to Withdraw Consent:</strong> You can opt-out of marketing communications at any time.</p>
        </section>

        <section>
          <h2>6. Data Security</h2>
          <p>We implement AES-256 encryption and secure socket layer (SSL) technology to protect your financial transactions. While we strive for 100% security, please remember that no method of transmission over the internet is entirely infallible.</p>
        </section>

        <section>
          <h2>7. Grievance Redressal</h2>
          <p>In accordance with the IT Act, we have appointed a Grievance Officer to address any concerns or complaints.</p>
          
          <div className="grievance-box">
            <p><strong>Grievance Officer:</strong> {grievanceOfficer.name}</p>
            <p><strong>Email:</strong> <a href={`mailto:${grievanceOfficer.email}`}>{grievanceOfficer.email}</a></p>
            <p><strong>Address:</strong> {grievanceOfficer.address}</p>
          </div>
        </section>

        
      </div>

      <style jsx>{`
        .privacy-container {
          max-width: 900px;
          margin: 0 auto;
          padding: 2rem 1.5rem;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
          line-height: 1.6;
          color: #3a3a3a;
        }

        .privacy-content {
          background: #ffffff;
        }

        h1 {
          font-size: 2.2rem;
          font-weight: 600;
          color: #212121;
          margin-bottom: 0.5rem;
          padding-bottom: 0.5rem;
          border-bottom: 1px solid #e0e0e0;
        }

        .last-updated {
          color: #666;
          font-size: 0.9rem;
          margin-bottom: 1.5rem;
        }

        h2 {
          font-size: 1.4rem;
          font-weight: 600;
          color: #212121;
          margin: 2rem 0 1rem 0;
          padding-bottom: 0.3rem;
          border-bottom: 1px solid #f0f0f0;
        }

        p {
          margin-bottom: 1rem;
          text-align: left;
        }

        strong {
          color: #212121;
          font-weight: 600;
        }

        a {
          color: #e67e22;
          text-decoration: none;
        }

        a:hover {
          text-decoration: underline;
        }

        section {
          margin-bottom: 1rem;
        }

        .grievance-box {
          background-color: #f9f9f9;
          padding: 1rem 1.2rem;
          border-left: 4px solid #e67e22;
          margin: 1.5rem 0;
          font-size: 0.95rem;
        }

        .grievance-box p {
          margin: 0.5rem 0;
        }

        .footer-links {
          margin-top: 3rem;
          padding-top: 1.5rem;
          border-top: 1px solid #e0e0e0;
          text-align: left;
        }

        .footer-links a {
          color: #e67e22;
          font-weight: 500;
        }

        @media (max-width: 768px) {
          .privacy-container {
            padding: 1.5rem 1rem;
          }
          h1 {
            font-size: 1.8rem;
          }
          h2 {
            font-size: 1.3rem;
          }
        }
      `}</style>
    </div>
  );
};

export default PrivacyPolicy;